import { render } from "./InstitutionalWebsiteContainer.vue?vue&type=template&id=5eda598a"
import script from "./InstitutionalWebsiteContainer.vue?vue&type=script&lang=js"
export * from "./InstitutionalWebsiteContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__